import { Role } from '../../Helpers/AuthorizationDataProvider';

export interface Filters {
	[key: string]: string | boolean
}

export interface UsersResponse {
	bookmarkId?: string
	education: []
	firstName: string
	imageId: string
	lastName: string
	location?: string
	researchAreas?: string[]
	role: Role
	userId: string
	workExperience: string[]
}

export interface CardData {
	bookmarkId?: string
	education?: string[]
	id: string
	imageId: string
	key: string
	location?: string
	name: string
	researchAreas?: string[]
	status?: 'Pending' | 'Active' | 'Rejected' | 'Accepted'
	userType: Role
	workExperience: string[]
}

export type FilteringTypes = 'currentPosition' | 'institution' | 'role' | 'researchAreas' | 'languages' | 'isReachableByText' | 'isReachableByCall';

export enum TabStatus {
  Error = 'error',
  Loaded = 'loaded',
  Loading = 'loading',
}